import React from 'react';
import PropTypes from 'prop-types';

function ArrowDown({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );
}

export { ArrowDown };

ArrowDown.propTypes = {
  className: PropTypes.string,
};

ArrowDown.defaultProps = {
  className: null,
};
